import { createFileRoute } from "@tanstack/react-router";

import { DecisionsPage } from "./$workspace.decisions";

export const Route = createFileRoute("/$workspace/decisions/")({
  head: () => ({ meta: [{ title: "Decisions — Dravian Horizon" }] }),
  component: DecisionsPage,
});
